import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentReferenceDeleteMutationVariables = Types.Exact<{
  contentReference?: Types.InputMaybe<Types.ContentReferenceDeleteInput>
}>

export type ContentReferenceDeleteMutation = {
  __typename?: 'Mutation'
  contentReferenceDelete: {
    __typename?: 'ContentReferenceDeleteResponse'
    contentReference?: {
      __typename?: 'ContentReference'
      id?: string | null
      fromContentContentId?: number | null
      fromContentContentType?: string | null
      toContentContentId?: number | null
      toContentContentType?: string | null
      contentReferenceTypesId?: string | null
    } | null
  }
}

export const ContentReferenceDeleteDocument = gql`
  mutation ContentReferenceDelete($contentReference: ContentReferenceDeleteInput) {
    contentReferenceDelete(contentReference: $contentReference) {
      contentReference {
        id
        fromContentContentId
        fromContentContentType
        toContentContentId
        toContentContentType
        contentReferenceTypesId
      }
    }
  }
`
export type ContentReferenceDeleteMutationFn = Apollo.MutationFunction<
  ContentReferenceDeleteMutation,
  ContentReferenceDeleteMutationVariables
>

/**
 * __useContentReferenceDeleteMutation__
 *
 * To run a mutation, you first call `useContentReferenceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentReferenceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentReferenceDeleteMutation, { data, loading, error }] = useContentReferenceDeleteMutation({
 *   variables: {
 *      contentReference: // value for 'contentReference'
 *   },
 * });
 */
export function useContentReferenceDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContentReferenceDeleteMutation,
    ContentReferenceDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContentReferenceDeleteMutation,
    ContentReferenceDeleteMutationVariables
  >(ContentReferenceDeleteDocument, options)
}
export type ContentReferenceDeleteMutationHookResult = ReturnType<
  typeof useContentReferenceDeleteMutation
>
export type ContentReferenceDeleteMutationResult =
  Apollo.MutationResult<ContentReferenceDeleteMutation>
export type ContentReferenceDeleteMutationOptions = Apollo.BaseMutationOptions<
  ContentReferenceDeleteMutation,
  ContentReferenceDeleteMutationVariables
>
